import { render, staticRenderFns } from "./editRelCaseDialog.vue?vue&type=template&id=4cc6d6c0"
import script from "./editRelCaseDialog.vue?vue&type=script&lang=js"
export * from "./editRelCaseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports